import { storeMixin, storeGenerator, parseApiUrl, parseFilters, parseOrderBy, handleError } from '@/storeMixin'
import { merge } from 'lodash'
import { axiosThux } from '@/axiosThux'

const eligibility = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: 'api/v1/document/{profile}/upload-document/',
    app: 'dashboard'
  },
  actions: {
    async getList ({ state, commit, getters, dispatch }) {
      let url = `${parseApiUrl(this, state.apiUrl)}deadline-health-suitability/?`
      url = `${url}${getters.perPage ? 'per_page=' + getters.perPage : ''}`
      url = `${url}${getters.page ? '&page=' + getters.page : ''}`
      url = `${url}${
        getters.orderBy ? '&order_by__=' + getters.orderBy : ''
      }`
      url = parseOrderBy(getters, url)
      url = parseFilters(getters, url)
      return axiosThux.get(url)
        .then(response => {
          commit('setList', response.data)
          commit('setPerPage', response.data.per_page)
        }).catch(error => {
          handleError(commit, dispatch, error)
        })
    },
    async downloadSummary ({ state, commit, getters, dispatch }, { simpleFileName = 'export.xls', columns = null }) {
      let url = `${parseApiUrl(this, state.apiUrl)}deadline-export/eligibility/?no_page=no_page`
      url = `${url}${
        getters.orderBy ? '&order_by__=' + getters.orderBy : ''
      }`
      url = parseOrderBy(getters, url)
      url = parseFilters(getters, url)
      return axiosThux({
        url: url,
        method: 'POST',
        data: { columns },
        responseType: 'blob'
      }).then(
        response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', simpleFileName)
          document.body.appendChild(link)
          link.click()
        }
      ).catch(error => {
        handleError(commit, dispatch, error)
      })
    }
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'dashboard', model: 'eligibility' }
    ),
    {
      GENERIC: {
        dashboard: {
          eligibility: {
            LIST: {
              ACTIONS: {
                downloadSummary: 'GENERIC/dashboard/eligibility/downloadSummary'
              }
            }
          }
        }
      }
    }
  )
)()

export { eligibility, TYPES }
